import { ReactNode } from "react";
import {
  ForyouSwipeEngineContext,
  PlaylistSwipeEngineContext,
  useCreateForyouSwipeEngine,
  useCreatePlaylistSwipeEngine,
} from "@hooks/useSharedSwipe";

export function SharedSwipeProvider({ children }: { children: ReactNode }) {
  const foryouEngine = useCreateForyouSwipeEngine();
  const playlistEngine = useCreatePlaylistSwipeEngine();

  return (
    <ForyouSwipeEngineContext.Provider value={foryouEngine}>
      <PlaylistSwipeEngineContext.Provider value={playlistEngine}>
        {children}
      </PlaylistSwipeEngineContext.Provider>
    </ForyouSwipeEngineContext.Provider>
  );
}
